import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/feature/Sidebar';
import MobileHeader from '../../components/feature/MobileHeader';
import Footer from '../../components/Footer';
import { useEffect, useState } from 'react';
import apiService from '../../services/api';
import { useAuth } from '../../hooks/useAuth';

export default function Dashboard() {
  const [mega, setMega] = useState<any | null>(null);
  const [loto, setLoto] = useState<any | null>(null);
  const [pendingTickets, setPendingTickets] = useState<any[]>([]);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [syncing] = useState(false);
  const [syncInfo] = useState<{ imported: number; checked_tickets: number } | null>(null);
  const [stats, setStats] = useState<{ active: number; checked: number; prizes: number; total: number }>({ active: 0, checked: 0, prizes: 0, total: 0 });
  const { user } = useAuth();
  const navigate = useNavigate();

  const StarIcon = ({ className = '' }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
    </svg>
  );

  useEffect(() => {
    const load = async () => {
      const settled = await Promise.allSettled([
        apiService.getDraws('mega-sena'),
        apiService.getDraws('lotofacil'),
        apiService.getTickets('pending'),
        apiService.getNotifications(),
        apiService.getGames({ limit: 999 }),
        apiService.getGames({ status: 'pending', limit: 999 }),
        apiService.getGames({ status: 'checked', limit: 999 })
      ]);
      const get = (i: number) => (settled[i] && (settled[i] as any).status === 'fulfilled') ? (settled[i] as any).value : null;
      const megaDraws = get(0) || [];
      const lotoDraws = get(1) || [];
      const pending = get(2) || [];
      const notifs = get(3) || { data: [], total: 0 };
      const gamesAll = get(4) || { data: [], pagination: { total: 0 } };
      const gamesPending = get(5) || { data: [], pagination: { total: 0 } };
      const gamesChecked = get(6) || { data: [], pagination: { total: 0 } };
      setMega(megaDraws[0] || null);
      setLoto(lotoDraws[0] || null);
      setPendingTickets(Array.isArray(pending) ? pending : (pending?.data || []));
      setNotifications(notifs?.data || []);
      const allGames = gamesAll?.data || [];
      const pendingGames = gamesPending?.data || [];
      const checkedGames = gamesChecked?.data || [];
      const prizes = checkedGames.filter((g: any) => Number(g.prize || 0) > 0).length;
      const activeCount = (gamesPending?.pagination?.total ?? pendingGames.length);
      const checkedCount = (gamesChecked?.pagination?.total ?? checkedGames.length);
      const totalCount = (gamesAll?.pagination?.total ?? allGames.length);
      setStats({ active: activeCount, checked: checkedCount, prizes, total: totalCount });
    };
    load();
  }, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white">
      <Sidebar />
      <MobileHeader />
      
      <div className="md:ml-72 p-4 md:p-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold mb-2">Dashboard</h1>
            <p className="text-white/60 text-sm">Bem-vindo de volta, {(user?.email || '').split('@')[0]}! Confira suas apostas e resultados.</p>
          </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-3 px-4 py-2 bg-white/5 border border-white/10 rounded-full">
            <span className="text-sm font-bold text-green-300">Status: {Number(user?.is_pro) === 1 ? 'PRO' : 'FREE'}</span>
            <span className="text-sm text-white/80">{(user?.email || '').split('@')[0]}</span>
          </div>
          {syncing ? (
            <div className="px-4 py-2 bg-white/5 border border-white/10 rounded-full text-sm">
              <i className="ri-refresh-line animate-spin mr-2"></i>
              Sincronizando resultados...
            </div>
          ) : syncInfo ? (
            <div className="px-4 py-2 bg-white/5 border border-white/10 rounded-full text-sm">
              Importados {syncInfo.imported} concursos • Conferidos {syncInfo.checked_tickets} tickets
            </div>
          ) : null}
          {/* Removed user icon button as requested */}
        </div>
        </div>

        {/* Mega da Virada - Destaque */}
        <div className="relative mb-8">
          <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 via-emerald-500/20 to-teal-500/20 blur-3xl"></div>
          <div className="relative bg-gradient-to-br from-slate-800/90 to-slate-900/90 backdrop-blur-xl border border-green-500/30 rounded-3xl p-6 md:p-8 shadow-2xl overflow-hidden">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
                MEGA DA VIRADA
              </h3>
              <span className="px-3 md:px-4 py-1 text-xs font-bold bg-gradient-to-r from-green-500 to-emerald-600 rounded-full whitespace-nowrap">🔥 DESTAQUE</span>
            </div>
            <div className="flex items-start justify-between flex-wrap gap-6">
              <div className="min-w-0">
                <p className="font-black text-white leading-tight mb-2 text-4xl md:text-5xl lg:text-6xl xl:text-7xl break-words">R$ 1.000.000.000</p>
                <p className="text-white/60 text-sm mb-4">Prêmio estimado</p>
                <div className="flex items-center gap-2 text-sm text-green-400">
                  <i className="ri-fire-fill"></i>
                  <span className="font-medium">Alta procura</span>
                </div>
              </div>
              <button onClick={() => navigate('/gerar-apostas', { state: { lottery: 'mega-sena', mega_virada: true } })} className="px-8 py-4 text-base font-bold bg-gradient-to-r from-green-500 to-emerald-600 rounded-full hover:shadow-2xl hover:shadow-emerald-500/40 transition-all whitespace-nowrap cursor-pointer">
                Gerar Apostas Agora
              </button>
            </div>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {[
            { icon: 'star', label: 'Jogos Ativos', value: String(stats.active), color: 'from-cyan-500 to-blue-600' },
            { icon: 'ri-checkbox-circle-line', label: 'Conferidos', value: String(stats.checked), color: 'from-green-500 to-emerald-600' },
            { icon: 'ri-award-line', label: 'Prêmios', value: String(stats.prizes), color: 'from-yellow-500 to-orange-600' },
            { icon: 'ri-magic-line', label: 'Apostas Geradas', value: String(stats.total), color: 'from-purple-500 to-pink-600' }
          ].map((stat, idx) => (
            <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 hover:border-white/20 transition-all">
              <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 flex items-center justify-center bg-gradient-to-br ${stat.color} rounded-xl`}>
                  {stat.icon === 'star' ? (
                    <StarIcon className="w-6 h-6 text-white" />
                  ) : (
                    <i className={`${stat.icon} text-xl text-white`}></i>
                  )}
                </div>
                <i className="ri-arrow-right-up-line text-green-400"></i>
              </div>
              <p className="text-3xl font-bold mb-1">{stat.value}</p>
              <p className="text-white/60 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Últimos Resultados */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          {/* Mega-Sena */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-xl font-bold mb-1">Mega-Sena</h3>
                <p className="text-white/60 text-sm">{mega ? `Concurso ${mega.contest_number} - ${new Date(mega.draw_date).toLocaleDateString()}` : 'Carregando...'}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl">
                {mega ? (
                  <StarIcon className="w-6 h-6 text-white" />
                ) : (
                  <i className="ri-loader-4-line text-xl animate-spin"></i>
                )}
              </div>
            </div>
            <div className="flex items-center gap-3 mb-4">
              {(mega?.numbers || []).map((num: number, idx: number) => (
                <div key={idx} className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-green-500/20 to-emerald-500/20 border border-green-500/30 rounded-xl font-bold">
                  {num}
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-white/60">Prêmio: {mega?.prize_breakdown?.estimated_prize ? `R$ ${mega.prize_breakdown.estimated_prize}` : 'Consultar'} {mega?.prize_breakdown?.rollover ? '• Acumulou' : (mega?.prize_breakdown?.winners_count ? `• ${mega.prize_breakdown.winners_count} ganhadores` : '')}</span>
              <Link to="/historico" className="text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer">
                Ver detalhes <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* Lotofácil */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-xl font-bold mb-1">Lotofácil</h3>
                <p className="text-white/60 text-sm">{loto ? `Concurso ${loto.contest_number} - ${new Date(loto.draw_date).toLocaleDateString()}` : 'Carregando...'}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-600 rounded-xl">
                {loto ? (
                  <StarIcon className="w-6 h-6 text-white" />
                ) : (
                  <i className="ri-loader-4-line text-xl animate-spin"></i>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2 mb-4 flex-wrap">
              {(loto?.numbers || []).map((num: number, idx: number) => (
                <div key={idx} className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500/20 to-rose-500/20 border border-pink-500/30 rounded-lg font-bold text-sm">
                  {num}
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between text-sm">
              <span className="text-white/60">Prêmio: {loto?.prize_breakdown?.estimated_prize ? `R$ ${loto.prize_breakdown.estimated_prize}` : 'Consultar'} {loto?.prize_breakdown?.rollover ? '• Acumulou' : (loto?.prize_breakdown?.winners_count ? `• ${loto.prize_breakdown.winners_count} ganhadores` : '')}</span>
              <Link to="/historico" className="text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer">
                Ver detalhes <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>

        {/* Removed: Tickets Pendentes & Notificações cards as requested */}
        <Footer />
      </div>
    </div>
  );
}
